import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=2f1bb839&scoped=true&"
import script from "./SubscriptionView.vue?vue&type=script&lang=js&"
export * from "./SubscriptionView.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/SubscriptionView/SubscriptionView.less?vue&type=style&index=0&id=2f1bb839&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bb839",
  null
  
)

export default component.exports